import type { LDFlagSet } from 'launchdarkly-electron-client-sdk';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { launchdarklyFlags } from '../../../launchdarklyFlags';

export const useFlagsFallback = () => {
  const flags = useFlags();
  if (!!flags && typeof flags === 'object' && Object.keys(flags).length) {
    return flags;
  }
  return launchdarklyFlags as LDFlagSet;
};
